import React from 'react';
import { SVG } from 'system';
import { ReactComponent as AssetLogoSVG } from 'src/assets/logo.svg';
export const Logo = props => React.createElement(SVG, Object.assign({
  svg: AssetLogoSVG,
  x: 2165.43,
  y: 393.59
}, props));